import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { VehicleDetailsView } from "./vehicleDetailsView";
import { navigateBack, navigateNext, stepProgress, } from "../../../dataBase/stepProgress";
import { STEP_VEHICLEDETAILS } from "../../../const/catalog";
import { useDispatch, useSelector } from "react-redux";
import { getCarColor, getCarColorClearData, getVehicles, getVehiclesClearData, } from "../../../store/vehiclesApap/actions";
import { useNavigate } from "react-router-dom";
import { Steps } from "../../../enum/steps";
import LocalStorageService from "../../../services/localStorage";
import { useGetPlansAll } from "../../../fnx/plans/plansGetAll";
import { useTranslation } from "react-i18next";
import { dataEditVehicleForm, } from "./vehicleDetailsDTO";
import { useGetCarChassisPlate } from "../../../fnx/apap/vehicles/carChassisPlatePost";
import showToast from "../../../services/toast";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
import { AlertLoadingHeader } from "../../../components/alertLoadingComponent/alertLoading";
var storageKey = "afy-steps";
var localStorageService = new LocalStorageService(storageKey);
var STEP = STEP_VEHICLEDETAILS;
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var VehicleDetails = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var t = useTranslation().t;
    var _h = React.useState([]), steps = _h[0], setSteps = _h[1];
    var projectId = localStorageService.getStepStored().steps[Steps.insurance].id;
    var _j = useState(false), trigger = _j[0], setTrigger = _j[1];
    var _k = useState(false), triggerChassisPlate = _k[0], setTriggerChassisPlate = _k[1];
    var _l = useState(false), enabledNextBtn = _l[0], setEnabledNextBtn = _l[1];
    var _m = useState(false), isValidating = _m[0], setIsValidating = _m[1];
    var _o = useState(false), enabledNextBtnII = _o[0], setEnabledNextBtnII = _o[1];
    var _p = useState({
        data: {
            type: "VEHICLE",
            fields: [],
        },
    }), pChassisPlateRequest = _p[0], setPchassisPlateRequest = _p[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _q = React.useState([]), breadCrumbs = _q[0], setBreadCrumbs = _q[1];
    var _r = React.useState(false), loading = _r[0], setLoading = _r[1];
    var _s = React.useState([]), carDetailsOption = _s[0], setCarDetailsOption = _s[1];
    var _t = React.useState([]), carColorOption = _t[0], setCarColorOption = _t[1];
    var limitSearchCar = React.useState(500000000)[0];
    var limitSearchColor = React.useState(500000000)[0];
    var limit = React.useState(50000000000)[0];
    var _u = React.useState(""), plate = _u[0], setPlate = _u[1];
    var _v = React.useState(""), chassis = _v[0], setChassis = _v[1];
    var insurance = React.useState(localStorageService.getStepStored().steps[Steps.insurance].name)[0];
    var projectType = React.useState((_d = (_c = (_b = (_a = localStorageService.getStepStored().steps[Steps.insurance]) === null || _a === void 0 ? void 0 : _a.flow) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.navigation) === null || _d === void 0 ? void 0 : _d.productType)[0];
    var campaign = React.useState((_e = localStorageService.getStepStored().steps[Steps.insurance]) === null || _e === void 0 ? void 0 : _e.campaign)[0];
    var campaignSelected = React.useState((_f = localStorageService.getStepStored().steps[Steps.insurance]) === null || _f === void 0 ? void 0 : _f.campaignSelected.id)[0];
    var dataCar = React.useState((_g = localStorageService.getStepStored().steps[Steps.vehiclesDetails]) === null || _g === void 0 ? void 0 : _g.vehiclesDetails)[0];
    var _w = React.useState(""), planSelected = _w[0], setPlanSelected = _w[1];
    var initializeFormVehicle = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        var storedDataCar = (_a = localStorageService.getStepStored().steps[Steps.vehiclesDetails]) === null || _a === void 0 ? void 0 : _a.vehiclesDetails;
        if (storedDataCar) {
            return {
                carDetails: {
                    brand: {
                        id: (_c = (_b = storedDataCar.carDetails) === null || _b === void 0 ? void 0 : _b.brand) === null || _c === void 0 ? void 0 : _c.id,
                        name: (_e = (_d = storedDataCar.carDetails) === null || _d === void 0 ? void 0 : _d.brand) === null || _e === void 0 ? void 0 : _e.name,
                    },
                    model: {
                        id: (_g = (_f = storedDataCar.carDetails) === null || _f === void 0 ? void 0 : _f.model) === null || _g === void 0 ? void 0 : _g.id,
                        name: (_j = (_h = storedDataCar.carDetails) === null || _h === void 0 ? void 0 : _h.model) === null || _j === void 0 ? void 0 : _j.name,
                    },
                    version: {
                        id: (_l = (_k = storedDataCar.carDetails) === null || _k === void 0 ? void 0 : _k.version) === null || _l === void 0 ? void 0 : _l.id,
                        name: (_o = (_m = storedDataCar.carDetails) === null || _m === void 0 ? void 0 : _m.version) === null || _o === void 0 ? void 0 : _o.name,
                    },
                    cylinderCapacity: (_p = storedDataCar.carDetails) === null || _p === void 0 ? void 0 : _p.cylinderCapacity,
                    passengers: (_q = storedDataCar.carDetails) === null || _q === void 0 ? void 0 : _q.passengers,
                    tonnage: (_r = storedDataCar.carDetails) === null || _r === void 0 ? void 0 : _r.tonnage,
                    transmission: (_s = storedDataCar.carDetails) === null || _s === void 0 ? void 0 : _s.transmission,
                    type: (_t = storedDataCar.carDetails) === null || _t === void 0 ? void 0 : _t.type,
                    class: (_u = storedDataCar.carDetails) === null || _u === void 0 ? void 0 : _u.class,
                    weight: (_v = storedDataCar.carDetails) === null || _v === void 0 ? void 0 : _v.weight,
                },
                year: storedDataCar.year.toString(),
                carColor: {
                    id: (_w = storedDataCar.carColor) === null || _w === void 0 ? void 0 : _w.id,
                    name: (_x = storedDataCar.carColor) === null || _x === void 0 ? void 0 : _x.name,
                },
                chassisNumber: storedDataCar.chassisNumber,
                shortChassis: storedDataCar.shortChassis,
                price: storedDataCar.price,
                numberCylinders: {
                    id: (_y = storedDataCar.numberCylinders) === null || _y === void 0 ? void 0 : _y.id,
                    name: (_z = storedDataCar.numberCylinders) === null || _z === void 0 ? void 0 : _z.name,
                },
                fuelType: {
                    id: storedDataCar.fuelType.id,
                    name: storedDataCar.fuelType.name,
                },
                registrationNumber: storedDataCar.registrationNumber,
                carCondition: {
                    id: storedDataCar.carCondition.id,
                    name: storedDataCar.carCondition.name,
                },
            };
        }
        return dataEditVehicleForm;
    };
    var formVehicle = React.useState(initializeFormVehicle())[0];
    var _x = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _x[0], setSeeToast = _x[1];
    var _y = useGetPlansAll(trigger, clientId, projectId), responsePlans = _y.responsePlans, errorPlans = _y.errorPlans, loadingPlans = _y.loadingPlans;
    /*Llamada al api para validar placas y numero de chasis*/
    var _z = useGetCarChassisPlate(triggerChassisPlate, pChassisPlateRequest), responseCarChassisPlate = _z.responseCarChassisPlate, errorCarChassisPlate = _z.errorCarChassisPlate, loadingCarChassisPlate = _z.loadingCarChassisPlate;
    var _0 = useSelector(function (state) {
        var _a;
        return ({
            loadingGetVehicles: state.Vehicles.loadingGetVehicles,
            responseGetVehicles: (_a = state.Vehicles.responseGetVehicles) === null || _a === void 0 ? void 0 : _a.data,
            errorGetVehicles: state.Vehicles.errorGetVehicles,
        });
    }), loadingGetVehicles = _0.loadingGetVehicles, responseGetVehicles = _0.responseGetVehicles, errorGetVehicles = _0.errorGetVehicles;
    var _1 = useSelector(function (state) {
        var _a;
        return ({
            loadingCarColor: state.Vehicles.loadingCarColor,
            responseCarColor: (_a = state.Vehicles.responseCarColor) === null || _a === void 0 ? void 0 : _a.data,
            errorCarColor: state.Vehicles.errorCarColor,
        });
    }), loadingCarColor = _1.loadingCarColor, responseCarColor = _1.responseCarColor, errorCarColor = _1.errorCarColor;
    useEffect(function () {
        setBreadCrumbs(stepProgress(STEP, true));
        setSteps(stepProgress(STEP));
        setTrigger(true);
        callGetVehicles("");
        callGetCarColor("", limit);
    }, []);
    useEffect(function () {
        var hasValidItems = Array.isArray(responseCarChassisPlate) &&
            responseCarChassisPlate.length > 0 &&
            responseCarChassisPlate.some(function (item) { return item.catalogStatusQuote.code !== "C"; });
        if (hasValidItems) {
            if (chassis.trim()) {
                setEnabledNextBtn(true);
                showToastSuccessMessage("El chasis ingresado ya existe!", typeAlert.warning, setSeeToast);
            }
            if (plate.trim()) {
                setEnabledNextBtnII(true);
                showToastSuccessMessage("La placa ingresada ya existe!", typeAlert.warning, setSeeToast);
            }
        }
        else {
            if (chassis.trim()) {
                setEnabledNextBtn(false);
            }
            if (plate.trim()) {
                setEnabledNextBtnII(false);
            }
        }
        setTriggerChassisPlate(false);
        // dispatch(getCarChassisPlateClearData());
    }, [responseCarChassisPlate]);
    useEffect(function () {
        if (responseGetVehicles) {
            setCarDetailsOption(responseGetVehicles);
            dispatch(getVehiclesClearData());
        }
    }, [responseGetVehicles]);
    useEffect(function () {
        if (responseCarColor) {
            setCarColorOption(responseCarColor);
            dispatch(getCarColorClearData());
        }
    }, [responseCarColor]);
    useEffect(function () {
        if (responsePlans && (responsePlans === null || responsePlans === void 0 ? void 0 : responsePlans.length) > 0) {
            var plan = responsePlans[0];
            // localStorageService.setStepStored({
            //   id: plan.id,
            //   name: plan.name,
            //   step: Steps.plan,
            //   completed: false,
            //   campaign: campaign,
            //   campaignSelected: campaignSelected,
            //   coverType: {
            //     code: "C",
            //     description: "Titular solamente",
            //     id: "c24e3622-e228-4549-a814-41043d46339a",
            //   },
            //   paymentModeSelected: {
            //     code: "M",
            //     description: "Mensual",
            //     id: "386ba1a4-1a5f-421d-bd93-058f4d478130",
            //   },
            // });
            setPlanSelected(responsePlans[0].name);
        }
    }, [responsePlans]);
    var searchCarDetails = function (name) {
        if (name.length === 0) {
            callGetVehicles("");
        }
        if (name.length >= 2) {
            callGetVehicles(name);
        }
    };
    var searchCarColor = function (name) {
        if (name.length === 0) {
            callGetCarColor("", limit);
        }
        if (name.length >= 2) {
            callGetCarColor(name, limitSearchColor);
        }
    };
    var callGetVehicles = function (brand) {
        dispatch(getVehicles({
            brand: brand,
        }));
    };
    var callGetCarColor = function (color, limitGet) {
        dispatch(getCarColor({
            name: color,
            orderBy: "name",
            orderDir: "asc",
            limit: limitGet,
        }));
    };
    var onSelectCarDetails = function (value) {
        if (Object.keys(value).length === 0) {
            callGetVehicles("");
        }
    };
    var onSelectCarColor = function (value) {
        if (Object.keys(value).length === 0) {
            callGetCarColor("", limit);
        }
    };
    var onBackStep = function () {
        navigateBack(STEP, navigate);
    };
    var onNextStep = function (data) {
        // localStorageService.setStepStored({
        //   id: "",
        //   name: "",
        //   step: Steps.vehiclesDetails,
        //   completed: true,
        //   vehiclesDetails: data,
        // });
        navigateNext(STEP, navigate);
    };
    var onBlurChassis = function (data) {
        if (data) {
            setPlate("");
            setChassis(data);
            setPchassisPlateRequest({
                data: {
                    type: "VEHICLE",
                    fields: [
                        {
                            name: "chassis_number",
                            value: data,
                        },
                    ],
                },
            });
            setTriggerChassisPlate(true);
        }
    };
    var onBlurPlate = function (data) {
        if (data) {
            setChassis("");
            setPlate(data);
            setPchassisPlateRequest({
                data: {
                    type: "VEHICLE",
                    fields: [
                        {
                            name: "plate",
                            value: data,
                        },
                    ],
                },
            });
            setTriggerChassisPlate(true);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loading, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: t("loading") }), _jsx(VehicleDetailsView, { title: t("carDetails.titlePage"), projectType: projectType, loading: loading, steps: steps, breadCrumbs: breadCrumbs, searchCarDetails: searchCarDetails, searchCarColor: searchCarColor, loadingGetVehicles: loadingGetVehicles, loadingCarColor: loadingCarColor, carDetailsOption: carDetailsOption, carColorOption: carColorOption, onNextStep: onNextStep, onBackStep: onBackStep, insurance: insurance, t: t, onSelectCarDetails: onSelectCarDetails, onSelectCarColor: onSelectCarColor, planSelected: planSelected, formVehicle: formVehicle, onBlurChassis: onBlurChassis, onBlurPlate: onBlurPlate, enabledNextBtn: enabledNextBtn, enabledNextBtnII: enabledNextBtnII })] }));
};
